<template>
  <section class="groups">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('GROUP', 2) }) | formatTitle"></vue-headful>
    <group-list></group-list>

    <router-view class="groups__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import GroupList from './GroupList'

export default {
  name: 'groups',
  components: { GroupList }
}
</script>
